module.exports = {
  "zones": {
    "Asia/Kolkata": ["z", {
      "wallclock": -764121600000,
      "format": "IST",
      "abbrev": "IST",
      "offset": 19800000,
      "posix": -764145000000,
      "save": 0
    }, {
      "wallclock": -862617600000,
      "format": "+0630",
      "abbrev": "+0630",
      "offset": 19800000,
      "posix": -862637400000,
      "save": 3600000
    }, {
      "wallclock": -872035200000,
      "format": "IST",
      "abbrev": "IST",
      "offset": 19800000,
      "posix": -872058600000,
      "save": 0
    }, {
      "wallclock": -891561600000,
      "format": "+0630",
      "abbrev": "+0630",
      "offset": 19800000,
      "posix": -891581400000,
      "save": 3600000
    }, {
      "wallclock": -2019686400000,
      "format": "IST",
      "abbrev": "IST",
      "offset": 19800000,
      "posix": -2019705670000,
      "save": 0
    }, {
      "wallclock": -3155673600000,
      "format": "MMT",
      "abbrev": "MMT",
      "offset": 19270000,
      "posix": -3155694800000,
      "save": 0
    }, {
      "wallclock": -3645216000000,
      "format": "HMT",
      "abbrev": "HMT",
      "offset": 21200000,
      "posix": -3645237208000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 21208000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};